module.exports = __webpack_public_path__ + "static/media/value-proposition-free@2x.5c314e2b.png";